import React from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { updateAccount } from "@api/account"
import CountrySelect from "@src/components/country_select/"

const Address = ({ account, updateAccount }) => {
  return (
    <>
      <label className='cs-label' htmlFor='address_line1'>Address Line 1</label>
      <input
        id='address_line1'
        className='cs-input block col-12 mb1'
        value={account.address_line1 || ''}
        onChange={e => updateAccount({ address_line1: e.target.value })}
      />
      <label className='cs-label' htmlFor='address_line2'>Address Line 2</label>
      <input
        id='address_line2'
        className='cs-input block col-12 mb1'
        value={account.address_line2 || ''}
        onChange={e => updateAccount({ address_line2: e.target.value })}
      />
      <label className='cs-label' htmlFor='postal_code'>
        {account.country_code === 'US' ? 'Zip Code' : 'Postal Code'}
      </label>
      <input
        id='postal_code'
        className='cs-input block col-12 mb1'
        value={account.postal_code || ''}
        onChange={e => updateAccount({ postal_code: e.target.value })}
      />
      <CountrySelect
        className='mb1'
        value={account.country_code}
        onChange={value => updateAccount({ country_code: value })}
      />
      <div className='mb2'>
        <label className='cs-label' htmlFor='mobile_number'>Mobile Number</label>
        <input
          id='mobile_number'
          className='cs-input block col-12 mb1'
          value={account.mobile_number || ''}
          onChange={e => updateAccount({ mobile_number: e.target.value })}
        />
      </div>
    </>
  )
}

const mapStateToProps = state => ({
  account: state.account
})

const mapDispatchToProps = dispatch => ({
  updateAccount: bindActionCreators(updateAccount, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(Address)